require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.function.bind");

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.array.reduce");

!function (t, i) {
  "object" == typeof exports && "undefined" != typeof module ? i(exports) : "function" == typeof define && define.amd ? define(["exports"], i) : (t = t || self, i(t.tornis = {}));
}(this, function (t) {
  "use strict";

  function i(t, i) {
    var s = 0;
    return function () {
      var e = new Date().getTime();
      if (!(e - s < t)) return s = e, i.apply(void 0, arguments);
    };
  }

  function s(t) {
    return Math.floor(t.reduce(function (t, i) {
      return t + i;
    }, 0) / t.length);
  }

  var h = "undefined" == typeof window;

  var e =
  /*#__PURE__*/
  function () {
    function e() {
      _classCallCheck(this, e);

      h || (this.lastX = 0, this.lastY = 0, this.lastWidth = window.innerWidth, this.lastHeight = window.innerHeight, this.lastMouseX = 0, this.lastMouseY = 0, this.lastWindowX = window.screenX, this.lastWindowY = window.screenY, this.lastAlpha = 0, this.lastBeta = 0, this.lastGamma = 0, this.currAlpha = 0, this.currBeta = 0, this.currGamma = 0, this.scrollHeight = document.body.scrollHeight, this.scrollChange = !1, this.sizeChange = !1, this.mouseChange = !1, this.positionChange = !1, this.orientationChange = !1, this.currX = 0, this.currY = 0, this.currWidth = window.innerWidth, this.currHeight = window.innerHeight, this.currMouseX = 0, this.currMouseY = 0, this.currWindowX = 0, this.mouseXVelocity = [], this.mouseYVelocity = [], this.lastMouseXVelocity = 0, this.lastMouseYVelocity = 0, this.windowXVelocity = [], this.windowYVelocity = [], this.lastWindowXVelocity = 0, this.lastWindowYVelocity = 0, this.updating = !1, this.callbacks = [], this.update = this.update.bind(this), this.handleResize = this.handleResize.bind(this), this.handleMouse = this.handleMouse.bind(this), this.handleOrientation = this.handleOrientation.bind(this), this.recalibrateOrientation = this.recalibrateOrientation.bind(this), this.formatData = this.formatData.bind(this), this.watch = this.watch.bind(this), this.unwatch = this.unwatch.bind(this), this.handleResize = i(110, this.handleResize), this.handleMouse = i(75, this.handleMouse), window.addEventListener("resize", this.handleResize), window.addEventListener("mousemove", this.handleMouse), window.addEventListener("deviceorientation", this.handleOrientation), requestAnimationFrame(this.update));
    }

    _createClass(e, [{
      key: "handleResize",
      value: function handleResize(t) {
        this.currWidth = window.innerWidth, this.currHeight = window.innerHeight;
      }
    }, {
      key: "handleMouse",
      value: function handleMouse(t) {
        this.currMouseX = t.clientX, this.currMouseY = t.clientY;
      }
    }, {
      key: "handleOrientation",
      value: function handleOrientation(t) {
        this.initialAlpha || (this.initialAlpha = t.alpha), this.initialBeta || (this.initialBeta = t.beta), this.initialGamma || (this.initialGamma = t.gamma), this.currAlpha = t.alpha, this.currBeta = t.beta, this.currGamma = t.gamma;
      }
    }, {
      key: "recalibrateOrientation",
      value: function recalibrateOrientation() {
        var t = {
          prev: {
            alpha: this.initialAlpha,
            beta: this.initialBeta,
            gamma: this.initialGamma
          }
        };
        return this.initialAlpha = this.lastAlpha, this.initialBeta = this.lastBeta, this.initialGamma = this.lastGamma, t.current = {
          alpha: this.initialAlpha,
          beta: this.initialBeta,
          gamma: this.initialGamma
        }, t;
      }
    }, {
      key: "formatData",
      value: function formatData() {
        return {
          scroll: {
            changed: this.scrollChange,
            left: Math.floor(this.lastX),
            right: Math.floor(this.lastX + this.lastWidth),
            top: Math.floor(this.lastY),
            bottom: Math.floor(this.lastY + this.lastHeight),
            velocity: {
              x: Math.floor(this.scrollXVelocity) || 0,
              y: Math.floor(this.scrollYVelocity) || 0
            }
          },
          size: {
            changed: this.sizeChange,
            x: Math.floor(this.lastWidth),
            y: Math.floor(this.lastHeight),
            docY: Math.floor(this.scrollHeight)
          },
          mouse: {
            changed: this.mouseChange,
            x: Math.floor(this.lastMouseX),
            y: Math.floor(this.lastMouseY),
            velocity: {
              x: Math.floor(this.lastMouseXVelocity) || 0,
              y: Math.floor(this.lastMouseYVelocity) || 0
            }
          },
          position: {
            changed: this.positionChange,
            left: Math.floor(this.lastWindowX),
            right: Math.floor(this.lastWindowX + this.lastWidth),
            top: Math.floor(this.lastWindowY),
            bottom: Math.floor(this.lastWindowY + this.lastHeight),
            velocity: {
              x: Math.floor(this.lastWindowXVelocity) || 0,
              y: Math.floor(this.lastWindowYVelocity) || 0
            }
          },
          orientation: {
            changed: this.orientationChange,
            alpha: Math.floor(this.lastAlpha - this.initialAlpha) || 0,
            beta: Math.floor(this.lastBeta - this.initialBeta) || 0,
            gamma: Math.floor(this.lastGamma - this.initialGamma) || 0
          }
        };
      }
    }, {
      key: "update",
      value: function update() {
        var _this = this;

        var currWidth = this.currWidth,
            currHeight = this.currHeight,
            currMouseX = this.currMouseX,
            currMouseY = this.currMouseY,
            currAlpha = this.currAlpha,
            currBeta = this.currBeta,
            currGamma = this.currGamma;
        if (this.updating) return !1;
        this.scrollChange = this.sizeChange = this.mouseChange = this.positionChange = this.orientationChange = !1, this.windowXVelocity.length > 5 && this.windowXVelocity.shift(), this.windowXVelocity.push(window.screenX - this.lastWindowX), s(this.windowXVelocity) != this.lastWindowXVelocity && (this.lastWindowXVelocity = s(this.windowXVelocity), this.positionChange = !0), window.screenX != this.lastWindowX && (this.positionChange = !0, this.lastWindowX = window.screenX), this.windowYVelocity.length > 5 && this.windowYVelocity.shift(), this.windowYVelocity.push(window.screenY - this.lastWindowY), s(this.windowYVelocity) != this.lastWindowYVelocity && (this.lastWindowYVelocity = s(this.windowYVelocity), this.positionChange = !0), window.screenY != this.lastWindowY && (this.positionChange = !0, this.lastWindowY = window.screenY), window.pageXOffset == this.lastX && 0 != this.scrollXVelocity && (this.scrollXVelocity = 0, this.scrollChange = !0), window.pageYOffset == this.lastY && 0 != this.scrollYVelocity && (this.scrollYVelocity = 0, this.scrollChange = !0), window.pageXOffset != this.lastX && (this.scrollChange = !0, this.scrollXVelocity = Math.floor(window.pageXOffset - this.lastX), this.lastX = window.pageXOffset), window.pageYOffset != this.lastY && (this.scrollChange = !0, this.scrollYVelocity = Math.floor(window.pageYOffset - this.lastY), this.lastY = window.pageYOffset), currWidth != this.lastWidth && (this.lastWidth = currWidth, this.scrollHeight = document.body.scrollHeight, this.sizeChange = !0), currHeight != this.lastHeight && (this.lastHeight = currHeight, this.sizeChange = !0), this.mouseXVelocity.length > 5 && this.mouseXVelocity.shift(), this.mouseXVelocity.push(currMouseX - this.lastMouseX), s(this.mouseXVelocity) != this.lastMouseXVelocity && (this.lastMouseXVelocity = s(this.mouseXVelocity), this.mouseChange = !0), currMouseX != this.lastMouseX && (this.lastMouseX = currMouseX, this.mouseChange = !0), this.mouseYVelocity.length > 5 && this.mouseYVelocity.shift(), this.mouseYVelocity.push(currMouseY - this.lastMouseY), s(this.mouseYVelocity) != this.lastMouseYVelocity && (this.lastMouseYVelocity = s(this.mouseYVelocity), this.mouseChange = !0), currMouseY == this.lastMouseY && 0 == s(this.mouseYVelocity) || (this.lastMouseY = currMouseY, this.mouseChange = !0), currAlpha != this.lastAlpha && (this.lastAlpha = currAlpha, this.orientationChange = !0), currBeta != this.lastBeta && (this.lastBeta = currBeta, this.orientationChange = !0), currGamma != this.lastGamma && (this.lastGamma = currGamma, this.orientationChange = !0), (this.scrollChange || this.sizeChange || this.mouseChange || this.positionChange || this.orientationChange) && this.callbacks.forEach(function (t) {
          return t(_this.formatData());
        }), this.updating = !1, requestAnimationFrame(this.update);
      }
    }, {
      key: "watch",
      value: function watch(t) {
        var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        if ("function" != typeof t) throw new Error("Value passed to Watch is not a function");

        if (!h) {
          if (i) {
            var _i = this.formatData();

            _i.scroll.changed = !0, _i.mouse.changed = !0, _i.size.changed = !0, _i.position.changed = !0, _i.orientation.changed = !0, t(_i);
          }

          this.callbacks.push(t);
        }
      }
    }, {
      key: "unwatch",
      value: function unwatch(t) {
        if ("function" != typeof t) throw new Error("The value passed to unwatch is not a function");
        h || (this.callbacks = this.callbacks.filter(function (i) {
          return i !== t;
        }));
      }
    }]);

    return e;
  }();

  var a = new e();
  h || (window.__TORNIS = {
    watchViewport: a.watch,
    unwatchViewport: a.unwatch,
    getViewportState: a.formatData,
    recalibrateOrientation: a.recalibrateOrientation
  });
  var o = a.watch,
      n = a.unwatch,
      l = a.formatData,
      r = a.recalibrateOrientation;
  t.getViewportState = l, t.recalibrateOrientation = r, t.unwatchViewport = n, t.watchViewport = o, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});